
// Colors
const colors = {
    "Vital Ocean": 'linear-gradient(90deg, #1CB5E0 0%, #000851 100%)',
    "Kale Salad": 'linear-gradient(90deg, #00C9FF 0%, #92FE9D 100%)',
    "Disco Club": 'linear-gradient(90deg, #FC466B 0%, #3F5EFB 100%)',
    "Shady Lane": 'linear-gradient(90deg, #3F2B96 0%, #A8C0FF 100%)',
    "Retro Wagon": 'linear-gradient(90deg, #FDBB2D 0%, #22C1C3 100%)',
    "Default": 'linear-gradient(90deg, #3f51b5 0%, #3f51b5 100%)'
}
// Flexbox
const flexBox = {
    display: 'flex'
}
const flex = {
    flex_row_between: {
        ...flexBox,
        justifyContent: 'space-between'
    },
    flex_row_around: {
        ...flexBox,
        justifyContent: 'space-around'
    },
    flex_row_end: {
        ...flexBox,
        justifyContent: 'flex-end'
    },
    flex_row_start: {
        ...flexBox,
        justifyContent: 'flex-start'
    },
    flex_row_center: {
        ...flexBox,
        justifyContent: 'center'
    },
    flex_column_center: {
        ...flexBox,
        flexDirection: 'column',
        alignItems: 'center',
    },
    flex_column_start: {
        ...flexBox,
        flexDirection: 'column',
        alignItems: 'flex-start',
    }
}
// Fonts
const fonts = {
    default: {
        fontFamily: "RockSalt",
    },
    secondary: {
        fontFamily: "PatrickHand",
    }
}
// Link
const link = {
    textDecoration: 'none',
    curson: 'pointer'
}

// Component styles
const storyContainer = {
    height: '87vh',
    display: 'grid',
    justifyItems: 'center',
    maxWidth: 800,
    width: '90%'
}

const appheader = {
    large: {
        minHeight: `calc(100vh - 64px)`,
        paddingTop: `1rem`,
        display: `flex`,
        flexDirection: `column`,
        alignItems: `center`,
        color: `white`,
        fontSize: `calc(10px + 2vmin)`,
        marginTop: 64,
        textAlign: `center`,
    },
    small: {
        marginTop: 56,
        minHeight: `calc(100vh - 56px)`,
    }
}
const appSection = {

}

export {
    colors, flex, fonts, link, storyContainer, appheader, appSection
}